import { useContext } from "react";
import { match } from "ts-pattern";

import { TrainingBannerSoad } from "./TrainingBannerSoad.js";
import { LoggedInUserContext } from "~/Contexts.js";

export function TrainingBanner() {
  const userContext = useContext(LoggedInUserContext);

  return match(userContext?.user.sessionContext?.teamType)
    .with(
      undefined,
      "amhp",
      "cqc",
      "generic",
      "mha",
      "mca",
      "ward",
      "independent",
      "guest",
      "section-12-payment-reviewers",
      () => null,
    )
    .with("soad", () => <TrainingBannerSoad />)
    .exhaustive();
}
